import React from 'react'
import StatusList from '../components/status_list'

const timelineId = 'for-you'

const ForYouTimeline = () => (
  <StatusList
    scrollKey="for_you_timeline"
    timelineId={timelineId}
    endpoint="/api/v1/timelines/for_you"
    collectionType="featured"
    emptyMessage="Your timeline is empty. Start following other users to receive their content."
    usePages={false}
    showInjections
    showAds
  />
)

export default ForYouTimeline